/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Grid Item
 *
 * @file GridItem.jsx
 * @author Mohamed yasar arabath M
 * @since 0.0.2
 */
import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import withStylesProps from '../withStylesProps';
import GridItemStyles from './styles/GridItemStyles';

const GridItem = ({ classes, className, children }) => (
  <Box className={`${classes.gridItemContainer} ${className}`}>
    {children}
  </Box>
);

GridItem.defaultProps = {
  classes: {},
  className: '',
  colspan: 1
};

GridItem.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.object.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  colspan: PropTypes.number
};

export default withStylesProps(GridItemStyles)(GridItem);

